<template>
    <div :class="['flex', 'flex-col', 'mt-4', detail ? 'w-48 items-start' : 'w-32 items-center']">
        <!-- 详情显示切换badge -->
        <div class="mt-1 cursor-pointer flex items-center justify-center mb-4 mx-auto">
            <div :class="['badge', 'badge-primary', 'badge-lg', detail ? 'w-16' : 'w-8']" @click="handleSetDetail">
            </div>
        </div>

        <!-- 批量设置组件 -->
        <BatchSettings 
            :detail="detail" 
            :isLoading="isLoading"
            @loading-start="handleLoadingStart"
            @loading-end="handleLoadingEnd"
        />

        <!-- 标签编辑组件 -->
        <TagEditor 
            :detail="detail" 
            :isLoading="isLoading"
            :checkedData="checkedData"
            :filePath="filePath"
            @loading-start="handleLoadingStart"
            @loading-end="handleLoadingEnd"
        />

        <!-- 文件操作组件 -->
        <FileOperations 
            :detail="detail" 
            :isLoading="isLoading"
            :checkedData="checkedData"
            :filePath="filePath"
            @loading-start="handleLoadingStart"
            @loading-end="handleLoadingEnd"
        />

        <!-- 文本处理组件 -->
        <TextProcessor 
            :detail="detail" 
            :isLoading="isLoading"
            :checkedData="checkedData"
            :filePath="filePath"
            @loading-start="handleLoadingStart"
            @loading-end="handleLoadingEnd"
        />

        <!-- 媒体处理组件 -->
        <MediaProcessor 
            :detail="detail" 
            :isLoading="isLoading"
            :checkedData="checkedData"
            :filePath="filePath"
            :userRole="getUserRole"
            @loading-start="handleLoadingStart"
            @loading-end="handleLoadingEnd"
        />

        <!-- 文件索引组件 -->
        <FileIndexer 
            :detail="detail" 
            :isLoading="isLoading"
            :checkedData="checkedData"
            :filePath="filePath"
            :userRole="getUserRole"
            @loading-start="handleLoadingStart"
            @loading-end="handleLoadingEnd"
        />
    </div>
</template>

<script>
import BatchSettings from '@/components/batch/BatchSettings.vue'
import TagEditor from '@/components/batch/TagEditor.vue'
import FileOperations from '@/components/batch/FileOperations.vue'
import TextProcessor from '@/components/batch/TextProcessor.vue'
import MediaProcessor from '@/components/batch/MediaProcessor.vue'
import FileIndexer from '@/components/batch/FileIndexer.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'batchAction',
    components: {
        BatchSettings,
        TagEditor,
        FileOperations,
        TextProcessor,
        MediaProcessor,
        FileIndexer
    },
    data() {
        return {
            detail: false,
            isLoading: false
        }
    },
    computed: {
        ...mapGetters(['geFullPath', 'getUserRole']),
        filePath: {
            get() {
                const fullPath = this.geFullPath
                return fullPath
            }
        },
        checkedIds: {
            get() {
                return this.$store.state.common.checkedIds
            },
            set(value) {
                this.$store.commit('setCheckedIds', value)
            }
        },
        checkedData: {
            get() {
                return this.$store.state.common.checkedData
            },
            set(value) {
                this.$store.commit('setCheckedData', value)
            }
        }
    },
    mounted() {
        const savedDetail = window.localStorage.getItem('detail')
        if (savedDetail) {
            this.detail = savedDetail === 'true'
        }
    },
    methods: {
        handleSetDetail() {
            this.detail = !this.detail
            window.localStorage.setItem('detail', this.detail ? 'true' : 'false')
        },
        
        handleLoadingStart() {
            this.isLoading = true
        },

        handleLoadingEnd() {
            this.isLoading = false
        }
    }
}
</script>

<style scoped></style> 